import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default function TermsOfService() {
  return (
    <>
      <Header currentPage="terms" />

      {/* Page Header */}
      <section className="py-16 bg-gray-50 pt-24">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            TERMS OF SERVICE
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Please read these terms carefully before using our services
          </p>
        </div>
      </section>

      {/* Terms Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 mb-6">
                Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
              
              <p className="text-gray-700 leading-relaxed mb-6">
                Welcome to TAKT Construction Services Ltd. These Terms of Service govern your use of our website and services. By accessing or using our website, you agree to be bound by these terms.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Services</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                TAKT Construction Services Ltd. provides construction services including custom home construction, renovations, hardscapes, mass timber installation, and related services in the Greater Vancouver Region.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Use of Website</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                You may use our website for lawful purposes only. You agree not to use the website in any way that violates any applicable laws or regulations.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Contact Information</h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                For questions about these Terms of Service, please contact us at:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
                <li>Email: <a href="mailto:support@taktcon.com" className="text-blue-600 hover:text-blue-800">support@taktcon.com</a></li>
                <li>Phone: <a href="tel:+16048428258" className="text-blue-600 hover:text-blue-800">(604) 842-8258</a></li>
              </ul>

              <p className="text-gray-700 text-sm mt-8 pt-6 border-t border-gray-200">
                Note: This is a placeholder terms of service page. Please consult with legal counsel to develop comprehensive terms of service for your business.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}

